import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor() { }

  loadImage(fileList: FileList): Observable<string> {
    return new Observable((subscriber: Subscriber<any>) => {
      if (fileList.length === 0) {
        subscriber.error('Nenhum arquivo selecionado.')
        subscriber.complete()
      }
      let mimeType = fileList[0].type;
      if (mimeType.match(/image\/*/) == null) {
        subscriber.error('Apenas imagens são suportadas.')
        subscriber.complete()
      }
      let fileReader = new FileReader();
      fileReader.readAsDataURL(fileList[0]);
      fileReader.onload = () => {
        subscriber.next(fileReader.result)
        subscriber.complete()
      }
      fileReader.onerror = (error) => {
        subscriber.error(error)
        subscriber.complete()
      }
    })
  }
}
